import { setShowExportStatisticsModal } from '../../../State/showExportStatisticsModal';

export default () => async (dispatch) => {
  dispatch(setShowExportStatisticsModal(true));
}